(function() {
  "use strict";

  var dia = namespace('leica.pi.esm.archive.dialog');

  var archiveActions = (function () {
    var self = {};
    self.archiveReloadStatus = false;
    self.archiveRemoveBlocks = function () {
      $('#archiveContent .archive-continue').addClass('archive-dialog-hide');
      $('#archiveContent .archive-dialog-request').addClass('archive-dialog-hide')
      $('#archiveContent .archive-dialog-success').addClass('archive-dialog-hide')
      $('#archiveContent .archive-dialog-error').addClass('archive-dialog-hide')
    }
    function archiveDisableButtons () {
      $('#archive-dialog').prop('disabled',true);
      $('#cancel-dialog').prop('disabled',true);
      $('#ok-dialog').prop('disabled',true);
      $('.ui-dialog-titlebar-close').prop('disabled',true);
      $( "#restore-dialog" ).button( "option", "icon", "ui-icon-gear" );
    }
    function archiveEnableButtons () {
      $('.ui-dialog-titlebar-close').prop('disabled',false);
      $('#ok-dialog').prop('disabled',false);
      $('#archive-dialog').button().hide();
      $('#cancel-dialog').button().hide();
      $('#ok-dialog').button().show();
    }
    self.archiveItem = function (jsonObj) {
      $.ajax({
        method: "POST",
        url: jsonObj.page,
        data: {
          action: jsonObj.queryString.action,
          ParentId : jsonObj.queryString.ParentId,
          ParentTableName : jsonObj.queryString.ParentTableName
        },
        headers: {
          "Authorization" : 'Bearer ' + window.SystemParms.AuthToken 
        },
        beforeSend: function () {
          archiveEnableButtons();
          archiveDisableButtons();
          self.archiveRemoveBlocks();
          $('#archiveContent .archive-dialog-request').removeClass('archive-dialog-hide');
        }
      })
      .done(function(data) {
        self.archiveRemoveBlocks();
        if(parseInt(data.ASResult)) {
          $('#archiveContent .archive-dialog-error').removeClass('archive-dialog-hide');
        } else {
          $('#archiveContent .archive-dialog-success').removeClass('archive-dialog-hide');
          self.archiveReloadStatus =  true;
        }
        archiveEnableButtons();
      })
      .fail(function() {
        self.archiveRemoveBlocks();
        $('#archiveContent .archive-dialog-error').removeClass('archive-dialog-hide');
      });
    }

    return self;
  })();
  var restoreActions = (function () {
    var self = {};
    self.restoreReloadStatus = false;

    self.restoreRemoveBlocks = function () {
      $('#archiveRestoreContent .archive-continue').addClass('archive-dialog-hide');
      $('#archiveRestoreContent .archive-dialog-request').addClass('archive-dialog-hide')
      $('#archiveRestoreContent .archive-dialog-success').addClass('archive-dialog-hide')
      $('#archiveRestoreContent .archive-dialog-error').addClass('archive-dialog-hide')
    }
    function restoreDisableButtons () {
      $('#restore-dialog').prop('disabled',true);
      $('#cancel-dialog').prop('disabled',true);
      $('#ok-dialog').prop('disabled',true);
      $('.ui-dialog-titlebar-close').prop('disabled',true);
      $( "#restore-dialog" ).button( "option", "icon", "ui-icon-gear" );
    }
    function restoreEnableButtons () {
      $('.ui-dialog-titlebar-close').prop('disabled',false);
      $('#ok-dialog').prop('disabled',false);
      $('#restore-dialog').button().hide();
      $('#cancel-dialog').button().hide();
      $('#ok-dialog').button().show();
    }
    self.restoreItem = function (jsonObj) {
      $.ajax({
        method: "POST",
        url: jsonObj.page,
        data: {
          action: jsonObj.queryString.action,
          ParentId : jsonObj.queryString.ParentId,
          ParentTableName : jsonObj.queryString.ParentTableName
        },
       	headers: {
          "Authorization" : 'Bearer ' + window.SystemParms.AuthToken 
        },
        beforeSend: function () {
          restoreEnableButtons();
          restoreDisableButtons();
          self.restoreRemoveBlocks();
          $('#archiveRestoreContent .archive-dialog-request').removeClass('archive-dialog-hide');
        }
      })
        .done(function(data) {
          self.restoreRemoveBlocks();
          if(parseInt(data.ASResult)) {
            $('#archiveRestoreContent .archive-dialog-error').removeClass('archive-dialog-hide');
          } else {
            $('#archiveRestoreContent .archive-dialog-success').removeClass('archive-dialog-hide');
            self.restoreReloadStatus =  true;
          }
          restoreEnableButtons();
        })
        .fail(function() {
          self.restoreRemoveBlocks();
          $('#archiveRestoreContent .archive-dialog-error').removeClass('archive-dialog-hide');
        });
    }
    return self;
  })();

  dia.archive = function (jsonObj) {
    $('#triggerArchive').on('click', function(){
      if($(this).hasClass('Disabled') || $("#doNotArchive").hasClass('Modified')) {
        return;
      }
      $('#archiveContent').dialog({
        modal: true,
        title: 'Archive Record',
        resizable: false,
        draggable: false,
        height: 'auto',
        width: 500,
        closeText: 'Close Dialog',
        buttons: [{
              id      : "archive-dialog",
              text    : "Archive",
              title   : "Archive Images",
              tabIndex: -1,
              click   : function () {
                archiveActions.archiveItem (jsonObj);
              }
            },{
              id      : "cancel-dialog",
              text    : "Cancel",
              title   : "Close Dialog",
              tabIndex: -1,
              click   : function () {
                $(this).dialog("close");
              },
            },{
              id      : "ok-dialog",
              text    : "OK",
              title   : "Close Dialog",
              tabIndex: -1,
              hide: false,
              click   : function () {
                if (archiveActions.archiveReloadStatus) {
                  location.reload();
                }
                $(this).dialog("close");
              }
            }],
        close: function(event, ui){
          $(this).dialog("close");
        },
        beforeClose: function( event, ui ) {
          archiveActions.archiveRemoveBlocks();
          $('#archiveContent .archive-continue').removeClass('archive-dialog-hide');
        }
      });
    });
  }

  dia.restore = function (jsonObj) {
    $('#triggerRestore').on('click', function(){
      if($(this).hasClass('Disabled')) {
        return;
      }
      $('#archiveRestoreContent').dialog({
        modal: true,
        title: 'Restore Record',
        resizable: false,
        draggable: false,
        height: 210,
        width: 500,
        closeText: 'Close Dialog',
        buttons: [{
              id      : "restore-dialog",
              text    : "Continue",
              title   : "Continue Restoring Images",
              tabIndex: -1,
              click   : function () {
                restoreActions.restoreItem (jsonObj);
              }
            },{
              id      : "cancel-dialog",
              text    : "Cancel",
              title   : "Close Dialog",
              tabIndex: -1,
              click   : function () {
                $(this).dialog("close");
              },
            },{
              id      : "ok-dialog",
              text    : "OK",
              title   : "Close Dialog",
              tabIndex: -1,
              hide: false,
              click   : function () {
                if (restoreActions.restoreReloadStatus) {
                  location.reload();
                }
                $(this).dialog("close");
              }
            }],
        close: function(event, ui){
          $(this).dialog("close");
        },
        beforeClose: function( event, ui ) {
          restoreActions.restoreRemoveBlocks();
          $('#archiveRestoreContent .archive-continue').removeClass('archive-dialog-hide');
        }
      });
    });
  };
})();

var archiveDialog = namespace.using("leica.pi.esm.archive.dialog");